import { AccountManager } from '../types/bevmaq.types';

const accountManagersJSON: { [l: string]: AccountManager } = {
  'es-ES': {
    name: 'Sergi Ferran',
    email: 's.ferran@bevmaq.com',
    profile_picture:
      'https://storage.googleapis.com/bevmaq-crm-api/static-images/Sergi_Ferran.jpg',
    phone: '+34 651 686 805',
  },
  'en-US': {
    name: 'Carsten Hormes',
    email: 'c.hormes@bevmaq.com',
    profile_picture:
      'https://storage.googleapis.com/bevmaq-crm-api/static-images/carsten_hormes.png',
    phone: '+49 173 90 80 414',
  },
  'en-GB': {
    name: 'Jamie Kenyon',
    email: 'j.kenyon@bevmaq.com',
    profile_picture:
      'https://storage.googleapis.com/bevmaq-crm-api/static-images/jamie_kenyon.png',
    phone: '+44 7813 827466',
  },
  'fr-FR': {
    name: 'Hervé Pichard',
    email: 'h.pichard@bevmaq.com',
    profile_picture:
      'https://storage.googleapis.com/bevmaq-crm-api/static-images/herve_pichard.png',
    phone: '+33 6 46 63 77 52',
  },
  'de-DE': {
    name: 'Carsten Hormes',
    email: 'c.hormes@bevmaq.com',
    profile_picture:
      'https://storage.googleapis.com/bevmaq-crm-api/static-images/carsten_hormes.png',
    phone: '+49 173 90 80 414',
  },
  'pl-PL': {
    name: 'Jacek Chwist',
    email: 'j.chwist@bevmaq.com',
    profile_picture:
      'https://gindumac.s3.eu-central-1.amazonaws.com/staff/profile_pictures/jacek-chwist.png',
    phone: '+48 502 956 980',
  },
  'it-IT': {
    name: 'Carsten Hormes',
    email: 'c.hormes@bevmaq.com',
    profile_picture:
      'https://storage.googleapis.com/bevmaq-crm-api/static-images/carsten_hormes.png',
    phone: '+49 173 90 80 414',
  },
  'cs-CZ': {
    name: 'Carsten Hormes',
    email: 'c.hormes@bevmaq.com',
    profile_picture:
      'https://storage.googleapis.com/bevmaq-crm-api/static-images/carsten_hormes.png',
    phone: '+49 173 90 80 414',
  },
  'de-AT': {
    name: 'Stefan Garbe',
    email: 's.garbe@bevmaq.com',
    profile_picture:
      'https://storage.googleapis.com/bevmaq-public/Stefan_garbe.png',
    phone: '+49 151 5650 2523',
  },
};
export default accountManagersJSON;
